export default __webpack_public_path__ + "static/media/Renato's Bow.1e20a6b8.jpg";